const key2label = {
  摘要: 'abstract_ab',
  申请号: 'application_num',
  公开号: 'publication_number',
  优先权号: 'priority_num',
  专利维持期: 'patent_duration',
  申请日: 'application_date',
  公开日: 'publication_date',
  优先权日: 'priority_date',
  失效日: 'expired_date',
  '申请人(原始)': 'applicants_stat',
  申请人: 'applicants_stat',
  发明人: 'inventors',
  '专利权人(当前)': 'assignees_stat',
  专利权人: 'assignees_normal_stat',
  代理人: 'agent',
  代理人机构: 'agency',
  代理机构: 'agency',
  申请人国: 'country_name',
  申请人地址: 'applicant_addr',
  专利权人地址: 'assignees_addr',
  '申请人省份（中国）': 'province_name',
  '申请人城市（中国）': 'city_name',
  '申请人区县（中国）': 'district_name',
  奖励届次: 'award_sess',
  奖励名称: 'award_level',
  权利要求数: 'claims_num',
  专利类型: 'patent_type_cn_stat',
  ICP分类号: 'ipc_main_stat_detail',
  // 'CPC分类号': ['cpc_section_stat', 'cpc_mainclass_stat', 'cpc_subclass_stat', 'cpc_maingroup_stat', 'cpc_subgroup_stat'],
  国民经济分类号: 'icnea4_stat',
  CPC分类号: 'cpc_li',
  战略新兴产业分类号: 'sei_level_2',
  法律信息: 'legal_event_status_json',
  成果介绍: 'describe',
  IPC分类号: 'ipc_li',
  科研团队: 'team',
  奖励等级: 'award_name'
}

const describeConfig = [
  {
    title: '摘要',
    slotName: 'infos',
    componentName: 'Infos',
    noTitle: true, // 没标题
    isVHtml: true, //
    isCustom: true, // 自定义内容
    content: {
      摘要: '-'
    }
  },
  {
    title: '号码和日期',
    slotName: 'infos',
    componentName: 'Infos',
    isCustom: true, // 自定义内容
    content: {
      申请号: '-',
      公开号: '-',
      优先权号: '-',
      专利维持期: '-',
      申请日: '-',
      公开日: '-',
      优先权日: '-',
      失效日: '-'
    }
  },
  {
    title: '相关人信息',
    slotName: 'infos',
    componentName: 'Infos',
    isCustom: true, // 自定义内容
    content: {
      '申请人(原始)': '-',
      申请人: '-',
      发明人: '-',
      '专利权人(当前)': '-',
      专利权人: '-',
      代理人: '-',
      代理机构: '-'
    }
  },
  {
    title: '地址',
    slotName: 'infos',
    componentName: 'Infos',
    isCustom: true, // 自定义内容
    content: {
      申请人国: '-',
      申请人地址: '-',
      专利权人地址: '-'
    }
  },
  {
    title: '其他信息',
    slotName: 'infos',
    componentName: 'Infos',
    isCustom: true, // 自定义内容
    content: {
      奖励名称: '-',
      奖励等级: '-',
      奖励届次: '-',
      权利要求数: '-',
      专利类型: '-'
    }
  },
  {
    title: '分类信息',
    slotName: 'infos',
    componentName: 'Infos',
    isCustom: true, // 自定义内容
    // icnea1_stat  国民经济
    // ipc_main, ipc_main_stat(主)
    content: {
      IPC分类号: '-',
      国民经济分类号: '-',
      战略新兴产业分类号: '-',
      CPC分类号: '-'
    }
  },
  {
    title: '法律信息',
    slotName: 'infos',
    componentName: 'LawInfo',
    isCustom: true, // 自定义内容
    content: {
      法律信息: '-'
    }
  },
  {
    title: '成果介绍',
    slotName: 'infos',
    componentName: 'Infos',
    isCustom: true, // 自定义内容
    noTitle: true,
    fromDetailApi: true, // 从原本成果详情中获取成果介绍
    content: {
      成果介绍: '-'
    }
  },
  {
    title: '科研团队',
    slotName: 'infos',
    componentName: 'Infos',
    isCustom: true, // 自定义内容
    noTitle: true,
    fromDetailApi: true, // 从原本成果详情中获取成果介绍
    content: {
      科研团队: '-'
    }
  },
  {
    title: '成果评估',
    slotName: 'infos',
    componentName: 'AssessmentResult',
    isCustom: true // 自定义内容
  }
]

module.exports = {
  key2label,
  describeConfig
}
